module.exports = __webpack_public_path__ + "img/logo.db7c795d.svg";